import useInitVersion from "@/components/resume/hooks/useInitVersion";
import useVersionKeyboard from "@/components/resume/hooks/useVersionKeyboard";

export default () => {
    useInitVersion();
    useVersionKeyboard();
}
